import { filterL } from "fxjs/es";
export const getLockedEls = (self) => {
  const working_layer = self._getWorkingLayerThrowable();
  const locking = self._getLockingThrowable();
  return new Set(
    filterL((el) => locking.getIsLocked(el))(working_layer.getGraphicsEls())
  );
};
